const __WEBPACK_NAMESPACE_OBJECT__ = window["ngx-extended-pdf-viewer"];